import { render, staticRenderFns } from "./GroupedRecommendedProducts.vue?vue&type=template&id=c310e3ac&"
import script from "./GroupedRecommendedProducts.vue?vue&type=script&lang=js&"
export * from "./GroupedRecommendedProducts.vue?vue&type=script&lang=js&"
import style0 from "./GroupedRecommendedProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupedRecommendedProducts.vue"
export default component.exports